export default __webpack_public_path__ + "static/media/eraser-solid.c5a5f6bc.svg";